import React from 'react';
import { useLocation, Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Select, Button, Avatar, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { getRouteName } from '../../utils/routes';
import './Header.css';

const { Option } = Select;

const Header = ({ user, onLogout, investmentType, onSelectInvestmentType, availableTypes, isPreviewMode }) => {
  let { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  if (pathname.startsWith('/indexes/')) { pathname = '/indexes'; }
  const title = getRouteName(pathname);

  // URL에서 dataType 파라미터 확인
  const urlDataType = searchParams.get('dataType');
  
  const shouldShowInvestmentTypeSelector = user && !isPreviewMode && ((user.type === 'admin') || (user.type !== 'admin' && availableTypes && availableTypes.length > 1));

  // URL 파라미터에 따라 현재 선택된 투자 유형 결정
  const getCurrentInvestmentType = () => {
    if (pathname === '/fixed-income-flow-history') return 'fixed-income';
    if (urlDataType === 'legacy') return 'crypto';
    if (urlDataType === 'preferred-return') return 'preferred-return';
    if (urlDataType === 'fixed-income') return 'fixed-income';
    return investmentType || 'crypto';
  };

  // 투자 유형 선택 시 리다이렉트 처리
  const handleInvestmentTypeChange = (value) => {
    if (typeof onSelectInvestmentType === 'function') {
      onSelectInvestmentType(value);
    }
    const currentPath = pathname;
    const currentSearchParams = new URLSearchParams(searchParams);
    
    // 현재 URL과 동일한지 확인하여 무한 루프 방지
    const newDataType = value === 'crypto' ? 'legacy' : value;
    if (currentPath === '/fixed-income-flow-history' && newDataType !== 'fixed-income') {
      navigate(`/dashboard?dataType=${newDataType}`);
      return;
    }
    const newUrl = `${currentPath}?dataType=${newDataType}`;
    const currentUrl = `${currentPath}?${currentSearchParams.toString()}`;
    
    if (newUrl !== currentUrl) {
      navigate(newUrl);
    }
  };

  const userMenuItems = [
    {
      key: 'account-settings',
      label: 'Account Settings',
      icon: <SettingOutlined />,
      onClick: () => {
        const currentType = getCurrentInvestmentType();
        const dataType = currentType === 'crypto' ? 'legacy' : currentType;
        navigate(`/account-settings?dataType=${dataType}`);
      }
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: onLogout
    }
  ];

  return (
    <>
      <Helmet><title>{`${!!title && `${title} | `} VegaX Dashboard`}</title></Helmet>
      <header className="header">
        <div className="header-left">
          {title && title !== 'Contact Us' && (
            <div className="header-title">
              <span className="title-text">{title}</span>
            </div>
          )}
        </div>
        
        <div className="header-right">
          {shouldShowInvestmentTypeSelector && (
            <div className="investment-type-section">
              <span className="investment-type-label">Investment Type</span>
              <Select 
                value={getCurrentInvestmentType()} 
                onChange={handleInvestmentTypeChange} 
                className="investment-type-select" 
                size="small"
              >
                {availableTypes?.includes('legacy') && (
                  <Option value="crypto">Digital Assets</Option>
                )}
                {availableTypes?.includes('preferred-return') && 
                availableTypes?.includes('fixed-income') && (
                  <Option value="preferred-return">Preferred Return</Option>
                )}
                {availableTypes?.includes('preferred-return') && 
                availableTypes?.includes('fixed-income') && (
                  <Option value="fixed-income">Fixed Income</Option>
                )}
                {availableTypes?.includes('preferred-return') && 
                !availableTypes?.includes('fixed-income') && (
                  <Option value="preferred-return">Preferred Return</Option>
                )}
                {availableTypes?.includes('fixed-income') && 
                !availableTypes?.includes('preferred-return') && (
                  <Option value="fixed-income">Fixed Income</Option>
                )}
              </Select>
            </div>
          )}
          
          {user && (
            <div className="user-section">
              <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
                <Button type="text" className="user-menu-button">
                  <Avatar size="small" icon={<UserOutlined />} className="user-avatar" />
                  <span className="user-name">{user.name || 'User'}</span>
                </Button>
              </Dropdown>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
